import React, { createContext, useContext, useState, useEffect } from "react";
import axios from "axios";

// Create The Context
const TokenContext = createContext();

// Custom Hook To Use The TokenContext
export const useToken = () => useContext(TokenContext);

export const TokenProvider = ({ children }) => {
  const [token, setToken] = useState(null);

  // Function To Fetch Token
  const fetchToken = async () => {
    try {
      const username = process.env.REACT_APP_TOKEN_USERNAME;
      const password = process.env.REACT_APP_TOKEN_PASSWORD;
      const type = process.env.REACT_APP_TOKEN_TYPE;
      const baseUrl = process.env.REACT_APP_API_BASE_URL;

      const response = await axios.get(
        `${baseUrl}/api/v1/generate-token?username=${username}&password=${password}&Type=${type}`
      );

      if (response.data && response.data.data) {
        setToken(response.data.data);
        return response.data.data;
      }
    } 
    catch (error) {
      fetchToken();
      return null;
    }
  };

  useEffect(() => {
    // Fetch Token On Mount
    fetchToken();

    // Set Interval To Refresh Token Every 15 Minutes (900,000 ms)
    const interval = setInterval(() => {
      fetchToken();
    }, 15 * 60 * 1000);

    // Cleanup Interval On Unmount
    return () => clearInterval(interval);
  }, []);

  return (
    <TokenContext.Provider value={{ token, fetchToken }}>
      {children}
    </TokenContext.Provider>
  );
};